<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="equals">est</option>
  </select>

  <div class="ml-2">
    <select [(ngModel)]="filter.tempValue" class="form-control max-width-240px" (ngModelChange)="filterChange.emit(filter)">
      <option [value]="userTypology.CB" jhiTranslate="filters.payment-method.CB"></option>
      <option [value]="userTypology.SEPA" jhiTranslate="filters.payment-method.SEPA"></option>
      <option [value]="userTypology.OFFLINE" jhiTranslate="filters.payment-method.OFFLINE"></option>
      <option [value]="userTypology.INIT_TRANSFERT_IMMEDIATE" jhiTranslate="filters.payment-method.INIT_TRANSFERT_IMMEDIATE"></option>
      <option [value]="userTypology.INIT_TRANSFERT_DEFERRED" jhiTranslate="filters.payment-method.INIT_TRANSFERT_DEFERRED"></option>
    </select>
  </div>
</div>
